import { useQuery } from '@tanstack/react-query';
import axios from 'axios';
import { useContext } from 'react';
import SessionContext from '../../contexts/SessionContext';
import API_URL from '../../constants/environment';
import { InventoryUnitsResponse } from '../../types/inventory';

const getInventoryUnits = async (sessionId: string): Promise<InventoryUnitsResponse> => {
    const { data } = await axios.get(`${API_URL}/inventory/units`, {
        headers: { Authorization: sessionId },
    });
    return data;
};

export const useGetInventoryUnits = (enabled = true) => {
    const sessionContext = useContext(SessionContext);

    return useQuery({
        queryKey: ['/inventory/units', sessionContext?.organizationId ?? ''],
        queryFn: () => getInventoryUnits(sessionContext?.sessionId ?? ''),
        enabled: !!sessionContext?.sessionId && enabled,
        staleTime: 5 * 60 * 1000,
    });
};
